import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsibleGamingService {

  public customer: CustomerModel;

  constructor(
      private userSession: UserSessionService,
      private webservice: WebservicesService) {

      this.userSession.getCustomer().subscribe(
          (customer) => {
              this.customer = customer;
          }
      );
  }

  getGlobalLimits() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-global-limits', obj);
  }

  getLimitHistory() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-limit-history', obj);
  }

  getDepositLimit() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-deposit-limit', obj);
  }

  setDepositLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
      }

      if (data.deposit_daily_limit != null && data.deposit_daily_limit != "") {
          obj.daily = data.deposit_daily_limit;
      }

      if (data.deposit_weekly_limit != null && data.deposit_weekly_limit != "") {
          obj.weekly = data.deposit_weekly_limit;
      }

      if (data.deposit_monthly_limit != null && data.deposit_monthly_limit != "") {
          obj.monthly = data.deposit_monthly_limit;
      }

      return this.webservice.post('responsibleGaming/set-deposit-limit', obj);
  }

  deleteDepositLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
          termType: data.termType
      }

      return this.webservice.post('responsibleGaming/delete-deposit-limit', obj);
  }

  getSpendLimit() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-wager-limit', obj);
  }

  setSpendLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
      }

      if (data.spend_daily_limit != null && data.spend_daily_limit != "") {
          obj.daily = data.spend_daily_limit;
      }

      if (data.spend_weekly_limit != null && data.spend_weekly_limit != "") {
          obj.weekly = data.spend_weekly_limit;
      }

      if (data.spend_monthly_limit != null && data.spend_monthly_limit != "") {
          obj.monthly = data.spend_monthly_limit;
      }

      return this.webservice.post('responsibleGaming/set-wager-limit', obj);
  }

  deleteSpendLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
          termType: data.termType
      }

      return this.webservice.post('responsibleGaming/delete-wager-limit', obj);
  }

  getTimeLimit() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-time_limit', obj);
  }

  getTotalLoginTime(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
          clientapp: data
      }

      return this.webservice.get('responsibleGaming/get-total-login-time', obj);
  }

  setTimeLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
      }

      if (data.daily != null && data.daily != "") {
          obj.daily = data.daily;
      }

      if (data.weekly != null && data.weekly != "") {
          obj.weekly = data.weekly;
      }

      if (data.monthly != null && data.monthly != "") {
          obj.monthly = data.monthly;
      }

      return this.webservice.post('responsibleGaming/set-time-limit', obj);
  }

  deleteTimeLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
          termType: data.termType
      }

      return this.webservice.post('responsibleGaming/delete-time-limit', obj);
  }

  getWagerLimit() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-wager-limit', obj);
  }

  setWagerLimit(data: any) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
      }

      if (data.wager_single_max_limit != null && data.wager_single_max_limit != "") {
          obj.single = data.wager_single_max_limit;
      }

      return this.webservice.post('responsibleGaming/set-wager-limit', obj);
  }

  //PA regulatory webservices

  getAllPendingLimit() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/get-pending-limits', obj);
  }

    confirmAllExceptDepositLimit(data: any) {
        let obj: any = {
            confirm: data.userSelection,
            customer_limit_id: data.customerLimitID,
            customer_id: this.customer.customerId,
            session_token: this.userSession.sessionToken
        }

        return this.webservice.post('responsibleGaming/apply-limit', obj);
    }

    confirmDepositLimit(data: any) {
        let obj: any = {
            confirm: data.userSelection,
            customer_id: this.customer.customerId,
            session_token: this.userSession.sessionToken,
            limit_term_type: data.termType
        }

        return this.webservice.post('responsibleGaming/apply-deposit-limit', obj);
    }

    //PA regulatory webservices

    deleteWagerLimit(data: any) {
        let obj: any = {
            customer_id: this.customer.customerId,
            session_token: this.userSession.sessionToken,
            termType: data.termType
        }

        return this.webservice.post('responsibleGaming/delete-wager-limit', obj);
    }



  public callCloseAccount() {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.get('responsibleGaming/close-account', obj);
  }

  /*
      POST /customer/resend-pin
  */
  public callResendPin(customerId?) {
      let customer_id = (!this.customer) ? customerId : this.customer.customerId;

      let obj: any = {
          customer_id: customer_id,
          session_token: this.userSession.sessionToken
      }

      return this.webservice.post('customer/resend-pin', obj);
  }

  public setCoolOff(days) {
      let obj: any = {
          customer_id: this.customer.customerId,
          session_token: this.userSession.sessionToken,
          days: days
      }
      return this.webservice.post('responsibleGaming/set-cool-off', obj);
  }

  public setSelfExclude(data: any) {
      let obj: any;
      if(data.excludePeriod == 6 || data.excludePeriod == "6")
      {
           obj = {
              customer_id: this.customer.customerId,
              session_token: this.userSession.sessionToken,
              self_exclude_period_months: data.excludePeriod,
              ssn: data.pin
          }
      }
      else {
           obj = {
              customer_id: this.customer.customerId,
              session_token: this.userSession.sessionToken,
              self_exclude_period: data.excludePeriod,
              ssn: data.pin
          }
      }


      return this.webservice.post('responsibleGaming/set-self-exclude', obj);
  }

  getLossLimit() {
      let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
      };

      return this.webservice.get("responsibleGaming/get-loss-limit", obj);
    }

    setLossLimit(data: any) {
      let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
      };

      if (data.loss_daily_limit != null && data.loss_daily_limit != "") {
        obj.daily = data.loss_daily_limit;
      }

      if (data.loss_weekly_limit != null && data.loss_weekly_limit != "") {
        obj.weekly = data.loss_weekly_limit;
      }

      if (data.loss_monthly_limit != null && data.loss_monthly_limit != "") {
        obj.monthly = data.loss_monthly_limit;
      }

      return this.webservice.post("responsibleGaming/set-loss-limit", obj);
    }

    deleteLossLimit(data: any) {
      let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        termType: data.termType,
      };

      return this.webservice.post("responsibleGaming/delete-loss-limit", obj);
    }
}
